import {
    fmtBytes,
    fmtMetricInteger,
    fmtPercent,
    fmtSign,
} from '.';

export function fmtBytesPerDayTrend(trend,total,options={}) {
    const { precision=0, bytesPrecision, percentPrecision } = options;
    return fmtSign(trend)+fmtBytes(trend,bytesPrecision||precision)+" "+fmtPercent(trend,total,percentPrecision||precision);
}

export function fmtObjectsPerDayTrend(trend,total,options={}) {
    const { precision=0, percentPrecision } = options;
    return fmtSign(trend)+fmtMetricInteger(trend)+" "+fmtPercent(trend,total,percentPrecision||precision);
}
